import React from 'react'
import DetailDisplay from './DetailDisplay'



export default function index() {

  return (
    
        <DetailDisplay/>
  )
}
